module.exports = __webpack_public_path__ + "static/media/dental.3b374503.svg";